import { render, staticRenderFns } from "./EditorChatPlugin.vue?vue&type=template&id=903619e0"
import script from "./EditorChatPlugin.vue?vue&type=script&lang=js"
export * from "./EditorChatPlugin.vue?vue&type=script&lang=js"
import style0 from "./EditorChatPlugin.vue?vue&type=style&index=0&id=903619e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports